import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { ProfileInformation, Nationality, DepositoryAgent, ListingOrCreditingInformation ,
         Company , Department , CostCenter , JobGrade , Termination , 
         AgentBank , UserRole , EmploymentStatus , UserList , UploadProfile ,
         NewProfile , GetUserProfile } from "../../models/profileInformation";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';

//================|| PROFILE SLICE ||=================//
type ProfileInformationState = {
    loading: boolean;
    error: any,
    myProfile: ProfileInformation | null;
    nationalities: Nationality[];
    depositoryAgents: DepositoryAgent[];
    company: Company[];
    department: Department[];
    costCenter: CostCenter[];
    jobGrade: JobGrade[];
    termination: Termination[];
    agentBank: AgentBank[];
    userRole: UserRole[];
    employmentStatus: EmploymentStatus[];
    userList: UserList[];
    uploadProfile: UploadProfile | null;
    NewUserResponseMessage: string;
    ResetPasswordResponseMessage: string;
    getUserProfile: GetUserProfile | null;
}
type ProfileInfo = {
    myProfile: ProfileInformation | null;
    nationalities: Nationality[];
    depositoryAgents: DepositoryAgent[];
}

type MasterInfo = {
    company: Company[];
    department: Department[];
    costCenter: CostCenter[];
    jobGrade: JobGrade[];
    termination: Termination[];
    nationalities: Nationality[];
    depositoryAgents: DepositoryAgent[];
    agentBank: AgentBank[];
    userRole: UserRole[];
    employmentStatus: EmploymentStatus[];
}

const initialState: ProfileInformationState = {
    loading: true,
    error: null,
    myProfile: null,
    nationalities: [],
    depositoryAgents: [],
    company: [],
    department: [],
    costCenter: [],
    jobGrade: [],
    termination: [],
    agentBank: [],
    userRole: [],
    employmentStatus: [],
    userList: [],
    uploadProfile: null,
    NewUserResponseMessage: '',
    ResetPasswordResponseMessage: '',
    getUserProfile: null
};

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type uploadfile = {
    sourcePath: File
}
type getfile = {
    csvtype: string
}
const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

export const getProfile = createAsyncThunk<ProfileInfo, {}, { rejectValue: ErrorInformation }>(
    "profile/getProfile",
    async ({ }, { rejectWithValue }) => {
        try {
            const nationalitiesResponse = await axios.get<Nationality[]>('/Misc/nationalities');
            const depositoryAgentsResponse = await axios.get<DepositoryAgent[]>('/Misc/depositoryagent');
            const profileRespoonse = await axios.get<ProfileInformation>('/Profile/getProfile')
            return {
                myProfile: profileRespoonse.data[0],
                nationalities: nationalitiesResponse.data,
                depositoryAgents: depositoryAgentsResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

export const getMasterProfile = createAsyncThunk<MasterInfo, {}, { rejectValue: ErrorInformation }>(
    "profile/getMasterProfile",
    async ({ }, { rejectWithValue }) => {
        try {
            const companyResponse = await axios.get<Company[]>('/Misc/getCompany');
            const departmentResponse = await axios.get<Department[]>('/Misc/getDepartment');
            const costCenterResponse = await axios.get<CostCenter[]>('/Misc/getCostCenter');
            const jobGradeResponse = await axios.get<JobGrade[]>('/Misc/getJobGrade');
            const terminationResponse = await axios.get<Termination[]>('/Misc/getTermination');
            const nationalitiesResponse = await axios.get<Nationality[]>('/Misc/nationalities');
            const depositoryAgentsResponse = await axios.get<DepositoryAgent[]>('/Misc/depositoryagent');
            const agentBankResponse = await axios.get<AgentBank[]>('/Misc/cpfagentbank');
            const userRoleResponse = await axios.get<UserRole[]>('/Misc/getUserRole');
            const employmentStatusResponse = await axios.get<EmploymentStatus[]>('/Misc/getEmploymentStatus');
            return {
                company: companyResponse.data,
                department: departmentResponse.data,
                costCenter: costCenterResponse.data,
                jobGrade: jobGradeResponse.data,
                termination: terminationResponse.data,
                nationalities: nationalitiesResponse.data,
                depositoryAgents: depositoryAgentsResponse.data,
                agentBank: agentBankResponse.data,
                userRole: userRoleResponse.data,
                employmentStatus: employmentStatusResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getUserList = createAsyncThunk(
    "profile/getUserList",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const updateProfile = createAsyncThunk(
    "profile/updateProfile",
    async (profileInformation: ListingOrCreditingInformation, { rejectWithValue }) => {
        const {
            userID,
            nameInCDP,
            nircInCDP,
            nationalityID,
            singaporePR,
            cdP1,
            cdP2,
            cdP3,
            depositoryAgentID,
            depAgentAccount1,
            depAgentAccount2,
            depAgentAccount3,
            cpfInvestmentBankID,
            cpfInvestmentBankAccount
        } = profileInformation;
        const listingOrCreditingInformation = {
            userID,
            nameInCDP,
            nircInCDP,
            nationalityID,
            singaporePR,
            cdP1,
            cdP2,
            cdP3,
            depositoryAgentID,
            depAgentAccount1,
            depAgentAccount2,
            depAgentAccount3,
            cpfInvestmentBankID,
            cpfInvestmentBankAccount
        }
        try {
            const response = await axios.put<ProfileInformation>('/Profile/updateESOPInfo', listingOrCreditingInformation)
            if (response.status === 200) {
                return profileInformation
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

export const postUploadProfile = createAsyncThunk(
    "profile/postUploadProfile",
    async (uploadfile: uploadfile, { rejectWithValue }) => {
        try {
            const optionpostUploadProfile = await axios.post<UploadProfile>('Profile/setUploadUserProfile',{
                sourcePath: uploadfile.sourcePath
            }, config);
            return optionpostUploadProfile.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getUploadUserProfile = createAsyncThunk(
    "profile/getUploadUserProfile",
    async (getfile: getfile, { rejectWithValue }) => {
        try {
            const getUploadUserProfileResponse = await axios.get<string>(`Profile/getUploadUserProfile?type=${getfile.csvtype}`)
            return getUploadUserProfileResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setManageUserProfile = createAsyncThunk<number, { newuserInfo: NewProfile }, { rejectValue: ErrorInformation }>(
    "profile/setManageUserProfile",
    async ({newuserInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/Profile/SetManageUserProfile', newuserInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

export const getSingleProfileUser = createAsyncThunk(
    "profile/getSingleProfileUser",
    async (profileUserID: number, { rejectWithValue }) => {
        try {
            const getSingleProfileUserResponse = await axios.get<GetUserProfile>(`Profile/getProfileUser?profileUserID=${profileUserID}`)
            return getSingleProfileUserResponse.data[0]
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const SetResetPassword = createAsyncThunk(
    "profile/SetResetPassword",
    async (profileUserID: number, { rejectWithValue }) => {
        try {
            const SetResetPasswordResponse = await axios.put<GetUserProfile>(`Profile/SetResetPassword?accountUserID=${profileUserID}`)
            return SetResetPasswordResponse.data[0]
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {},
    extraReducers: {
        //get profile
        [getProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [getProfile.fulfilled.type]: (state, action) => {
            const { myProfile, nationalities, depositoryAgents } = action.payload
            state.myProfile = myProfile;
            state.depositoryAgents = depositoryAgents;
            state.nationalities = nationalities;
            state.loading = false;
        },
        [getProfile.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        //get Master profile
        [getMasterProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [getMasterProfile.fulfilled.type]: (state, action) => {
            const { company , department , costCenter , jobGrade , termination , 
                nationalities, depositoryAgents , agentBank , userRole , employmentStatus } = action.payload
            state.company = company;
            state.department = department;
            state.costCenter = costCenter;
            state.jobGrade = jobGrade;
            state.termination = termination;
            state.depositoryAgents = depositoryAgents;
            state.nationalities = nationalities;
            state.agentBank = agentBank;
            state.userRole = userRole;
            state.employmentStatus = employmentStatus;
            state.loading = false;
        },
        [getMasterProfile.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get User List View
        [getUserList.pending.type]: (state) => {
            state.loading = true;
        },
        [getUserList.fulfilled.type]: (state, action) => {
            state.userList = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getUserList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        // Upload profile
        [postUploadProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [postUploadProfile.fulfilled.type]: (state, action) => {

            state.uploadProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [postUploadProfile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get Upload User Profile
        [getUploadUserProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [getUploadUserProfile.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        [getUploadUserProfile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // New User Profile
        [setManageUserProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [setManageUserProfile.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [setManageUserProfile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Single User Profile
        [getSingleProfileUser.pending.type]: (state) => {
            state.loading = true;
        },
        [getSingleProfileUser.fulfilled.type]: (state, action) => {
            state.getUserProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getSingleProfileUser.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Reset Password Profile
        [SetResetPassword.pending.type]: (state) => {
            state.loading = true;
        },
        [SetResetPassword.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.ResetPasswordResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [SetResetPassword.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // update profile
        [updateProfile.pending.type]: (state) => {
            state.loading = true;
        },
        [updateProfile.fulfilled.type]: (state, action) => {

            state.myProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [updateProfile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})

export default profileSlice